<template>
  <svg width="36" height="21" viewBox="0 0 36 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.00171 1.22668L1.00171 19.5335"
      stroke="#E10009"
      stroke-width="1.83068"
      stroke-linecap="round"
    />
    <g clip-path="url(#clip0_1_92650)">
      <path
        d="M32.5013 11.1887C32.7156 10.9742 32.8359 10.6834 32.8359 10.3802C32.8359 10.077 32.7156 9.78615 32.5013 9.57162L28.187 5.25503C27.9724 5.04038 27.6813 4.9198 27.3777 4.9198C27.0742 4.9198 26.783 5.04038 26.5684 5.25503C26.3538 5.46967 26.2332 5.76079 26.2332 6.06434C26.2332 6.36789 26.3538 6.65901 26.5684 6.87365L28.93 9.23599L20.1313 9.23599C19.8278 9.23599 19.5368 9.35654 19.3222 9.57111C19.1076 9.78569 18.9871 10.0767 18.9871 10.3802C18.9871 10.6836 19.1076 10.9746 19.3222 11.1892C19.5368 11.4038 19.8278 11.5243 20.1313 11.5243L28.93 11.5243L26.5684 13.8859C26.4621 13.9922 26.3778 14.1184 26.3203 14.2572C26.2628 14.3961 26.2332 14.5449 26.2332 14.6952C26.2332 14.8455 26.2628 14.9944 26.3203 15.1332C26.3778 15.2721 26.4621 15.3983 26.5684 15.5045C26.6747 15.6108 26.8008 15.6951 26.9397 15.7526C27.0786 15.8102 27.2274 15.8398 27.3777 15.8398C27.528 15.8398 27.6768 15.8102 27.8157 15.7526C27.9546 15.6951 28.0807 15.6108 28.187 15.5045L32.5013 11.1887Z"
        fill="#E10009"
      />
    </g>
    <g clip-path="url(#clip1_1_92650)">
      <path
        d="M3.50039 11.1887C3.28612 10.9742 3.16577 10.6834 3.16577 10.3802C3.16577 10.077 3.28612 9.78615 3.50039 9.57162L7.81469 5.25503C8.02933 5.04038 8.32045 4.9198 8.624 4.9198C8.92755 4.9198 9.21867 5.04038 9.43332 5.25503C9.64796 5.46967 9.76854 5.76079 9.76854 6.06434C9.76854 6.36789 9.64796 6.65901 9.43332 6.87365L7.07174 9.23599L15.8704 9.23599C16.1739 9.23599 16.4649 9.35654 16.6795 9.57111C16.8941 9.78569 17.0146 10.0767 17.0146 10.3802C17.0146 10.6836 16.8941 10.9746 16.6795 11.1892C16.4649 11.4038 16.1739 11.5243 15.8704 11.5243L7.07174 11.5243L9.43332 13.8859C9.5396 13.9922 9.6239 14.1184 9.68142 14.2572C9.73894 14.3961 9.76854 14.5449 9.76854 14.6952C9.76854 14.8455 9.73894 14.9944 9.68142 15.1332C9.6239 15.2721 9.5396 15.3983 9.43332 15.5045C9.32703 15.6108 9.20086 15.6951 9.062 15.7526C8.92314 15.8102 8.77431 15.8398 8.624 15.8398C8.4737 15.8398 8.32487 15.8102 8.18601 15.7526C8.04714 15.6951 7.92097 15.6108 7.81469 15.5045L3.50039 11.1887Z"
        fill="#E10009"
      />
    </g>
    <path
      d="M35 1.22668L35 19.5335"
      stroke="#E10009"
      stroke-width="1.83068"
      stroke-linecap="round"
    />
    <defs>
      <clipPath id="clip0_1_92650">
        <rect
          width="18.3068"
          height="18.3068"
          fill="white"
          transform="translate(35 1.22668) rotate(90)"
        />
      </clipPath>
      <clipPath id="clip1_1_92650">
        <rect
          width="18.3068"
          height="18.3068"
          fill="white"
          transform="matrix(0 1 1 -4.37114e-08 1.00171 1.22668)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ExpandIcon'
}
</script>
